<template>
  <svg width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <clipPath id="umumo5lcha">
        <path data-name="사각형 152322" style="fill:none" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
    <path data-name="패스 256359" d="M14 5V2.707l-5.01 5.01-.707-.707L13.293 2H11V1h4v4z" />
    <g data-name="그룹 276836">
      <g data-name="그룹 276835" style="clip-path:url(#umumo5lcha)">
        <path data-name="패스 256360" d="M13 7v6H3V3h6V2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'OpenNewFenetre',
};
</script>
